module.exports = __webpack_public_path__ + "assets/img/image_316.8fc5731e.png";